import { render, staticRenderFns } from "./TeamAddModal.vue?vue&type=template&id=7bd482c3"
import script from "./TeamAddModal.vue?vue&type=script&lang=js"
export * from "./TeamAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports